import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

const Contact = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you! We will contact you shortly.");
  };

  const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: isMobile ? "3rem 1.5rem" : isTablet ? "4.5rem 2rem" : "6rem 4rem",
  };

  const sectionTitle = {
    fontSize: isMobile ? "26px" : "38px",
    fontWeight: 700,
    color: "#1E1B4B",
    marginBottom: "20px",
  };

  const inputStyle = {
    width: "100%",
    padding: "14px 16px",
    borderRadius: "8px",
    border: "1px solid #E9E6F5",
    marginBottom: "16px",
    fontSize: "14px",
    outline: "none",
  };

  return (
    <>
      <section
        style={{
          background: "linear-gradient(135deg, #0F0A1F, #240046)",
          color: "#ffffff",
          padding: isMobile
            ? "4rem 1.5rem"
            : isTablet
              ? "5rem 2rem"
              : "6rem 4rem",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            fontSize: isMobile ? "30px" : "48px",
            fontWeight: 700,
          }}
        >
          Contact InnoByte
        </h1>

        <p
          style={{
            marginTop: "20px",
            fontSize: isMobile ? "15px" : "18px",
            color: "#DCD6F7",
            maxWidth: "700px",
            marginInline: "auto",
          }}
        >
          Let us discuss your requirements for data centres, Wi-Fi, networking,
          surveillance, structured cabling, and electronics infrastructure.
        </p>
      </section>

      <section style={{ backgroundColor: "#F5F3FF" }}>
        <div style={containerStyle}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isTablet ? "1fr" : "1fr 1.2fr",
              gap: isMobile ? "28px" : isTablet ? "36px" : "50px",
            }}
          >
            <div>
              <h2 style={sectionTitle}>Get in Touch</h2>

              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  marginBottom: "25px",
                  color: "#1E1B4B",
                  lineHeight: "24px",
                }}
              >
                <FaMapMarkerAlt
                  style={{
                    marginRight: "10px",
                    marginTop: "4px",
                    color: "#6A0DAD",
                    flexShrink: 0,
                  }}
                />

                <span>
                  Corporate Office: 3rd Floor, D Tower, Sai Enclave, Patna,
                  Bihar, India.
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "15px",
                }}
              >
                <FaPhoneAlt
                  style={{
                    marginRight: "10px",
                    color: "#6A0DAD",
                  }}
                />

                <a
                  href="tel:+919199997773"
                  style={{
                    textDecoration: "none",
                    color: "#1E1B4B",
                  }}
                >
                  +91 9199997773
                </a>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "30px",
                }}
              >
                <FaEnvelope
                  style={{
                    marginRight: "10px",
                    color: "#6A0DAD",
                  }}
                />

                <a
                  href="mailto:sales@innobyteindustries.com"
                  style={{
                    textDecoration: "none",
                    color: "#1E1B4B",
                    overflowWrap: "anywhere",
                  }}
                >
                  sales@innobyteindustries.com
                </a>
              </div>

              <div
                style={{
                  padding: "25px",
                  backgroundColor: "#ffffff",
                  borderRadius: "12px",
                  border: "1px solid #E9E6F5",
                  color: "#4B5563",
                  fontSize: "14px",
                  lineHeight: "24px",
                }}
              >
                We typically respond within 24 hours. Share your site scope,
                location, and timeline, and our team will suggest the right
                integration approach.
              </div>
            </div>

            <div
              style={{
                backgroundColor: "#ffffff",
                padding: isMobile ? "24px" : isTablet ? "32px" : "40px",
                borderRadius: "16px",
                border: "1px solid #E9E6F5",
                boxShadow: "0 12px 30px rgba(106, 13, 173, 0.08)",
              }}
            >
              <h2 style={sectionTitle}>Send Us a Message</h2>

              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  style={inputStyle}
                />

                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  style={inputStyle}
                />

                <input
                  type="text"
                  name="company"
                  placeholder="Company Name"
                  value={formData.company}
                  onChange={handleChange}
                  style={inputStyle}
                />

                <textarea
                  name="message"
                  rows="5"
                  placeholder="Describe your site, requirement, and expected timeline..."
                  required
                  value={formData.message}
                  onChange={handleChange}
                  style={{
                    ...inputStyle,
                    resize: "none",
                  }}
                />

                <button
                  type="submit"
                  style={{
                    background: "linear-gradient(90deg, #6A0DAD, #9D4EDD)",
                    padding: "12px 28px",
                    borderRadius: "8px",
                    color: "#ffffff",
                    border: "none",
                    fontWeight: 600,
                    cursor: "pointer",
                    boxShadow: "0 8px 20px rgba(157, 78, 221, 0.3)",
                    width: isMobile ? "100%" : "auto",
                  }}
                >
                  Submit Inquiry
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
